export default "__VITE_ASSET__CNaH9E5S__"